class ColorManager {
  constructor() {
    this.colorMap = {
      // German color names (lowercase)
      "schwarz": "#000000",
      "weiß": "#FFFFFF",
      "navy": "#000080",
      "rot": "#FF0000",
      "irisches grün": "#009B77",
      "hellblau": "#ADD8E6",
      "hellpink": "#FFB6C1",
      "rosa": "#FFC0CB",
      "kelly grün": "#4CBB17",
      "pink": "#FFC0CB",
      "ozeanblau": "#0077BE",
      "gelb": "#FFFF00",
      "grau": "#808080",
      "beere": "#8A2BE2",
      "aqua": "#00FFFF",
      "blattgrün": "#32CD32",
      "königsblau": "#4169E1",
      "beige": "#F5F5DC",

      // English color names (lowercase)
      "black": "#000000",
      "white": "#FFFFFF",
      "navy": "#000080",
      "red": "#FF0000",
      "irish green": "#009B77",
      "light blue": "#ADD8E6",
      "light pink": "#FFB6C1",
      "pink": "#FFC0CB",
      "kelly green": "#4CBB17",
      "ocean blue": "#0077BE",
      "yellow": "#FFFF00",
      "gray": "#808080",
      "berry": "#8A2BE2",
      "aqua": "#00FFFF",
      "leaf green": "#32CD32",
      "royal blue": "#4169E1",
      "beige": "#F5F5DC"
    };
  }

  setColor(element) {
    if (element) {
      // Convert color name to lowercase before checking in colorMap
      const colorName = element.getAttribute('data-value').toLowerCase();
      const colorValue = this.colorMap[colorName];
      if (colorValue) {
        element.style.backgroundColor = colorValue;
      }
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const colorManager = new ColorManager();
  const colorBoxes = document.querySelectorAll('.custom-option-colorbox');
  colorBoxes.forEach((colorBox) => {
    colorManager.setColor(colorBox);
  });
});
